import React from 'react';

const Terms = () => {
  return (
    <div className="main">
      <div className="container">
        <div className="legal-content">
          <h1>Terms of Service</h1>
          
          <div className="legal-highlight-box">
            <p><strong>Important Notice:</strong> By accessing and using CHALYATI's car rental services, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service. Please read them carefully.</p>
          </div>
          
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing and using CHALYATI's car rental services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to these terms, please do not use our services.</p>
          
          <div className="legal-section-divider"></div>
          
          <h2>2. Service Description</h2>
          <p>CHALYATI provides comprehensive car rental services through our online platform. We offer a diverse fleet of well-maintained vehicles for various rental periods, from hourly rentals to long-term leases, catering to both personal and business needs across India.</p>
          
          <h2>3. User Eligibility</h2>
          <p>To use our services, you must meet the following requirements:</p>
          <ul>
            <li>Be at least <strong>21 years old</strong> for standard vehicles</li>
            <li>Possess a valid driver's license for at least 2 years</li>
            <li>Have a clean driving record with no major violations</li>
            <li>International drivers must have an International Driving Permit (IDP)</li>
            <li>Provide valid government-issued identification</li>
          </ul>
          
          <h2>4. Booking and Reservations</h2>
          <p>All bookings are subject to vehicle availability and confirmation. We reserve the right to modify or cancel reservations due to operational requirements, vehicle maintenance, or unforeseen circumstances. In such cases, we will provide alternative arrangements or full refunds.</p>
          
          <div className="legal-section-divider"></div>
          
          <h2>5. Rental Requirements</h2>
          <p>Before renting a vehicle, you must provide:</p>
          <ul>
            <li>Valid government-issued photo identification</li>
            <li>Current driver's license</li>
            <li>Valid credit card for security deposit</li>
            <li>Proof of insurance (if applicable)</li>
            <li>Additional documentation for luxury or specialty vehicles</li>
          </ul>
          
          <h2>6. Vehicle Usage</h2>
          <div className="legal-highlight-box">
            <p><strong>Permitted Use:</strong> Vehicles must be operated in accordance with all applicable traffic laws and regulations. Only authorized drivers listed on the rental agreement may operate the vehicle.</p>
          </div>
          <p><strong>Prohibited Activities:</strong></p>
          <ul>
            <li>Off-road driving or racing</li>
            <li>Using the vehicle for commercial purposes without authorization</li>
            <li>Transporting hazardous materials</li>
            <li>Exceeding vehicle capacity limits</li>
            <li>Operating under the influence of alcohol or drugs</li>
          </ul>
          
          <h2>7. Insurance and Liability</h2>
          <p>Renters are fully responsible for any damage to the vehicle during the rental period. We strongly recommend purchasing our comprehensive insurance coverage for maximum protection. Basic liability coverage is included in all rentals.</p>
          
          <div className="legal-section-divider"></div>
          
          <h2>8. Fuel Policy</h2>
          <p>Vehicles are provided with a full tank of fuel and must be returned with the same fuel level. If returned with less fuel, additional charges will apply based on current market rates plus a service fee.</p>
          
          <h2>9. Late Returns</h2>
          <p>We provide a <strong>30-minute grace period</strong> for returns. Late returns beyond this period will incur additional charges equivalent to one full day's rental rate. Please contact us immediately if you anticipate a late return.</p>
          
          <h2>10. Cancellation Policy</h2>
          <p>Cancellation terms vary by booking type:</p>
          <ul>
            <li><strong>Free Cancellation:</strong> 24+ hours before pickup</li>
            <li><strong>50% Refund:</strong> 2-24 hours before pickup</li>
            <li><strong>No Refund:</strong> Less than 2 hours or no-show</li>
          </ul>
          
          <div className="legal-section-divider"></div>
          
          <h2>11. Prohibited Activities</h2>
          <p>The following activities are strictly prohibited in our vehicles:</p>
          <ul>
            <li>Smoking or vaping</li>
            <li>Transporting pets without prior approval</li>
            <li>Exceeding maximum passenger capacity</li>
            <li>Modifying or tampering with vehicle systems</li>
            <li>Using the vehicle for illegal activities</li>
          </ul>
          
          <h2>12. Maintenance and Breakdowns</h2>
          <p>In case of mechanical failure not caused by renter negligence, we provide 24/7 roadside assistance and will arrange for a replacement vehicle or provide appropriate compensation for the affected rental period.</p>
          
          <h2>13. Privacy and Data Protection</h2>
          <p>We collect and process personal information in accordance with our comprehensive Privacy Policy and applicable data protection laws. By using our service, you consent to such processing for service delivery and improvement purposes.</p>
          
          <div className="legal-section-divider"></div>
          
          <h2>14. Limitation of Liability</h2>
          <div className="legal-highlight-box">
            <p><strong>Liability Limitation:</strong> CHALYATI's total liability is limited to the rental charges paid for the affected period. We are not liable for indirect, incidental, consequential, or punitive damages.</p>
          </div>
          
          <h2>15. Governing Law</h2>
          <p>These terms are governed by the laws of India. Any disputes will be resolved through binding arbitration in accordance with Indian arbitration laws. The courts of India shall have exclusive jurisdiction over any legal proceedings.</p>
          
          <h2>16. Changes to Terms</h2>
          <p>We reserve the right to modify these terms at any time. Significant changes will be communicated via email, platform notifications, or website announcements. Continued use of our services constitutes acceptance of modified terms.</p>
          
          <div className="legal-contact-info">
            <h3>Contact Information</h3>
            <p>For questions about these Terms of Service, please contact us:</p>
            <p><strong>Email:</strong> support@chalyati.com</p>
            <p><strong>Phone:</strong> +91 80996 62446</p>
            <p><strong>WhatsApp:</strong> +91 80996 62446</p>
            <p><strong>Address:</strong> CHALYATI Car Rentals, India</p>
          </div>
          
          <div className="legal-last-updated">
            <p><strong>Last updated:</strong> December 2024</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;